import React from 'react';
import { useState } from 'react';
import OwlCarousel from 'react-owl-carousel';
import 'owl.carousel/dist/assets/owl.carousel.css';
import 'owl.carousel/dist/assets/owl.theme.default.css';
import { useNavigate } from 'react-router-dom';

import NairaIcon from './NairaIcon';

const NslProductList = () => {
    const navigate = useNavigate()

    const products = [
        {
            "name": "Value Adding Services",
            "description": "Explore our services to give you more value",
            "image": "https://miro.medium.com/v2/resize:fit:1000/0*FK1uFA80s8nUSTLK"
        },
        {
            "name": "Primary Market",
            "description": "We act on behalf of principal investors in primary issues",
            "image": "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRijIfVumNgKT_PQFCwocwOS380QW-hP9V-3FwqpP-nN843lGVFidcK6o0z3fIrDWEYKLQ&usqp=CAU"
        },
        {
            "name": "Secondary Market Trading",
            "description": "This involves the buying and selling of existing securities.",
            "image": "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSNlvD2hanpevfoFi7WzfVl7XVB6428zFOs__Wczl8Vn9hGqQptIXA_25P5q4hJzzXzOy8&usqp=CAU"
        },
        {
            "name": "Heritage Service",
            "description": "Simplifying the process of reclaiming lost shares and dividends",
            "image": "https://img.freepik.com/free-photo/african-american-financial-advisors-reviewing-real-time-market-data-statistics-order-sell-stocks-hedge-fund-traders-sitting-workstation-while-pointing-display-with-live-index-charts_482257-40566.jpg"
        }

    ];
    const [investmentAmount, setInvestmentAmount] = useState("")
    const flutterWaveKey = "FLWPUBK_TEST-d486f541c034283a8d7d47bb2672137c-X"

    function generateRandom6DigitNumber() {
        // Generate a random number between 100000 and 999999
        return Math.floor(100000 + Math.random() * 900000);
    }

    // Example usage:
    const txreference = generateRandom6DigitNumber();

    // get and store client details

    // check if client is corporate or individual.
    if (sessionStorage.getItem("corporate")) {
        console.log(sessionStorage.getItem("corporate"))
    }
    
    let name
    let email
    let payload

    if(sessionStorage.getItem('individualData')){
        payload = JSON.parse((sessionStorage.getItem('individualData')))
        console.log(payload)
        name = payload.firstname +" "+payload.last_name
        email = payload.primary_email_address
    }
    else if(sessionStorage.getItem('Corporate')){
        payload = JSON.parse((sessionStorage.getItem('Corporate')))
        console.log(payload)
        name = payload.organization_name
        email = payload.primary_email_address
    }
    else{
        navigate('https://onboarding.norrenberger.com')
    }
    return (
        <div>
            <h5 className="" style={{ marginBottom: "-5px" }}>Securities</h5>
            <small className="text-muted text-small mb-2">
                Make informed decisions and maximize your profits with Norrenberger's expert assistance.
            </small>
            <br /><br />
            <OwlCarousel
                items={4}
                className="owl-theme"
                loop
                autoplay
                autoplayTimeout={3000}
                autoplayHoverPause
                margin={8}
            >
                {products.map((product, index) => (
                    <div key={index}>
                        <div className="card">
                            {/* You can customize the image source and style as needed */}
                            <img
                                className="card-img-top"
                                src={product.image}
                                alt=""
                                style={{ height: "130px", objectFit: "cover" }}
                            />
                            <div className="card-body">
                                <h6 className="card-title bold text-small">{product.name}</h6>
                                <p className="card-text text-small">{product.description}</p>
                            </div>
                        </div>
                    </div>
                ))}
            </OwlCarousel>

            <div className="text-center my-3">
                <button className="btn-custom" data-bs-toggle="modal" data-bs-target="#nsl-checkout"><i className="bi-cash-stack me-2 mt-3"></i> Fund Trading Portfolio</button>
            </div>

            {/* ================================================ */}
            {/* MODAL CONTENT */}
            < div className="modal fade" id="nsl-checkout" >
                <div className="modal-dialog modal-sm">
                    <div className="modal-content">
                        {/* <!-- Modal Header --> */}
                        <div className="modal-header">
                            <div>
                                <h6 style={{ marginBottom: "-5px" }}>Trading Portfolio</h6>
                                <small className="text-muted text-small">Fund Portfolio</small>
                            </div>
                            <button type="button" className="btn-close" data-bs-dismiss="modal"></button>
                        </div>
                        {/* <!-- Modal body --> */}
                        <div className="modal-body">
                            <div className="">
                                <div className="">
                                    <div className="my-2">
                                        <h6 style={{ marginBottom: "-5px" }}><NairaIcon /> {investmentAmount || "0.00"}</h6>
                                        <small className="text-muted text-small">Investment Amount</small>
                                    </div>
                                    <form method="POST" action="https://checkout.flutterwave.com/v3/hosted/pay">
                                        <input type="number" name="amount" className="form-control custom-input" value={investmentAmount} placeholder="Select Amount" onChange={(e) => setInvestmentAmount(e.target.value)} required />
                                        <input type="hidden" name="public_key" value="FLWPUBK-721e76909b1668c9928490f1c59012d6-X" />
                                        {/* <input type="hidden" name="public_key" value="FLWPUBK_TEST-02b9b5fc6406bd4a41c3ff141cc45e93-X" /> */}
                                        <input type="hidden" name="customer[email]" value={email} />
                                        <input type="hidden" name="customer[name]" value={name} />
                                        <input type="hidden" name="tx_ref" value={txreference} />
                                        <input type="hidden" name="currency" value="NGN" />
                                        <input type="hidden" name="meta[source]" value="Norrenberger Product Onboarding" />
                                        <input type="hidden" name="redirect_url" value="localhost:3000" />
                                        <button type="submit" className="btn-custom w-100 mt-3" id="start-payment-button">Pay Now <i className="bi-chevron-right ms-2"></i></button>
                                    </form>
                                </div>
                            </div>
                        </div>

                    </div>
                </div>
            </div >
        </div>
    );
};

export default NslProductList;
